import React from 'react';

import { FormField } from '@gogame/form';

import { CHANNELS } from 'scenes/Gallery/GalleryPage/Creatives/constants';
import { loadChannels } from 'scenes/Gallery/GalleryPage/Creatives/sources/fields';
import {
  CREATIVE_TYPE_BANNER,
  CREATIVE_TYPE_CINEMAGRAPH,
  CREATIVE_TYPE_GIF,
  CREATIVE_TYPE_PLAYABLE,
  CREATIVE_TYPE_VIDEO,
} from 'scenes/Gallery/GalleryPage/constants';

export const ACTIVE = [
  CREATIVE_TYPE_BANNER,
  CREATIVE_TYPE_CINEMAGRAPH,
  CREATIVE_TYPE_GIF,
  CREATIVE_TYPE_PLAYABLE,
  CREATIVE_TYPE_VIDEO,
];

const ChannelsComponent = ({ creativeType, name = CHANNELS, padding }) => {
  const active = ACTIVE.includes(creativeType);

  return (
    <FormField.MultiSelect
      label={'Marketing partners'}
      name={name}
      active={active}
      source={loadChannels}
      padding={padding}
    />
  );
};

export default ChannelsComponent;
